<h1 mat-dialog-title>Upload Files</h1>
<mat-dialog-content>
  <mat-card class="dialog-content-container">
    <mat-card-content class="dialog-content">
      <input
        type="file"
        #inputElement
        multiple
        [accept]="allowedMIMETypes"
        class="cdk-visually-hidden"
        (change)="onChange($event)"
      />
      <button matButton="filled" (click)="openFileBrowser()">
        <mat-icon class="material-symbols-outlined">attach_file</mat-icon>Browse Files
      </button>

      <ul class="file-list bulletless">
        @for (fum of pendingUploadManagerMap().values(); track fum.id) {
          <li class="file-upload pending-upload">
            <span class="file-name">{{ fum.payload.file.name }}</span>
            <div class="file-status">(pending upload)</div>
          </li>
        }

        @for (fum of fileUploadManagerMap().values(); track fum.id) {
          @if (!fum.isExisting && !pendingUploadManagerMap().has(fum.id)) {
            <li class="file-upload">
              <span class="file-name">{{ fum.payload?.file?.name || fum.fileResponses[0]?.file_name }}</span>

              @if (fum.inProgress) {
                <div class="progress-bar-container">
                  <mat-progress-bar mode="determinate" [value]="fum.progress" />
                </div>
              } @else if (fum.uploadComplete) {
                <div class="file-upload-complete">Complete</div>
              } @else if (fum.canRetry) {
                <div class="file-upload-retry">
                  <a (click)="displayError(fum.errorMessage)">There was an error.</a>&nbsp;
                  <a (click)="uploadFile(fum)">Try again?</a>
                </div>
              }
            </li>
          }
        }

        @if (fileUploadManagerMap().size === 0 && pendingUploadManagerMap().size === 0) {
          <li class="empty-state"><p>Click the button above to select a file.</p></li>
        }
      </ul>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button matButton="filled" (click)="onUpload()" [disabled]="!canUpload()">
    <mat-icon class="material-symbols-outlined">upload</mat-icon>Upload ({{ pendingUploadManagerMap().size }})
  </button>
  <button matButton="filled" (click)="onClose()">
    <mat-icon class="material-symbols-outlined">close</mat-icon>Close
  </button>
</mat-dialog-actions>
